export enum StatusFiscalNFSeEntradaEnum {
    Regular = 1,
    Cancelada = 2
}
